import { render, staticRenderFns } from "./LdRelationshipsCheckoutBanner.vue?vue&type=template&id=73295284&scoped=true"
import script from "./LdRelationshipsCheckoutBanner.vue?vue&type=script&lang=js"
export * from "./LdRelationshipsCheckoutBanner.vue?vue&type=script&lang=js"
import style0 from "./LdRelationshipsCheckoutBanner.vue?vue&type=style&index=0&id=73295284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73295284",
  null
  
)

export default component.exports